export default "__VITE_ASSET__tRpb8uNL__"